import { ExternalLinkIcon, LogOutIcon } from 'assets';
import { useUserLogOut } from 'view/pages/auth/hooks/useUserLogOut';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useGetPrivacyAndTerms } from 'view/pages/auth/hooks/useGetPrivacyAndTerms';
import * as S from './styled';

interface MenuItem {
  id: number;
  text: string;
  link: string;
  endIcon: boolean;
  target?: string;
}

const userProfileMenu: Array<MenuItem> = [
  { id: 0, text: 'Profile Settings', link: '/profile/profile-settings', endIcon: false },
  { id: 1, text: 'Work Preferences', link: '/profile/work-preferences', endIcon: false },
  { id: 2, text: 'Account Settings', link: '/profile/account-settings', endIcon: false },
  {
    id: 3,
    text: 'Notifications Settings',
    link: '/profile/notifications-settings',
    endIcon: false,
  },
  { id: 4, text: 'Help Center', link: '/profile/help-center', endIcon: false, target: '_self' },
];

const externalLinks = [
  { id: 5, text: 'Terms of Use', link: 'termsAndConditions', endIcon: true, target: '_blank' },
  { id: 6, text: 'Privacy Policy', link: 'privacyPolicy', endIcon: true, target: '_blank' },
];

const UserProfileMobileMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { send } = useUserLogOut();
  const { getPrivacyAndTerms } = useGetPrivacyAndTerms();

  const [expanded, setExpanded] = useState<string | false>(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(userProfileMenu[0]);

  useEffect(() => {
    const currentItem = userProfileMenu.find((item) => {
      return item.link === location.pathname;
    });
    if (currentItem) {
      setSelectedMenuItem(currentItem);
    }
  }, [location.pathname]);

  const handleChange = (panel: string) => {
    return (_event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  };

  const handleMenuItemClick = (item: MenuItem) => {
    setSelectedMenuItem(item);
    navigate(item.link);
    setExpanded(false);
  };

  const filteredMenu = userProfileMenu.filter((item) => {
    return item.id !== selectedMenuItem?.id;
  });

  return (
    <S.MobileMenuWrapper>
      <S.CustomAccordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <S.AccordionTitle component="span">{selectedMenuItem.text}</S.AccordionTitle>
        </AccordionSummary>
        <AccordionDetails>
          {filteredMenu.map((item) => {
            return (
              <S.MenuExternalItemLink
                key={item.id}
                onClick={() => {
                  return handleMenuItemClick(item);
                }}
              >
                {item.text} {item.endIcon && <ExternalLinkIcon />}
              </S.MenuExternalItemLink>
            );
          })}
          {externalLinks.map((item) => {
            return (
              <S.MenuExternalItemLink
                key={item.id}
                onClick={() => {
                  if (item.link === 'termsAndConditions' || item.link === 'privacyPolicy') {
                    getPrivacyAndTerms(item.link);
                  }
                }}
              >
                {item.text} {item.endIcon && <ExternalLinkIcon />}
              </S.MenuExternalItemLink>
            );
          })}
          <S.MenuExternalItemLink
            onClick={() => {
              return send();
            }}
          >
            Sign Out <LogOutIcon />
          </S.MenuExternalItemLink>
        </AccordionDetails>
      </S.CustomAccordion>
    </S.MobileMenuWrapper>
  );
};

export default UserProfileMobileMenu;
